


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { HTMLTrapFocus } from '@/utils/htmlTrapFocus';
import { generateHash } from '@/author/components/helper/hash';

@Component
export default class KnowledgeCheckControls extends Vue {
  @Prop() submitLabel!: string;
  @Prop() learnMoreLabel?: string | undefined;
  @Prop() isSubmitDisabled!: string;
  @Prop() isCorrect!: boolean;
  @Prop({ default: '#fff' }) backgroundColor!: string;
  @Prop() correctFeedback!: string;
  @Prop() incorrectFeedback!: string;
  @Prop() correctRedFlagsMessage!: string;
  @Prop() incorrectRedFlagsMessage!: string;
  @Prop() themes!: string;
  @Prop() nextLabel!: string;
  @Prop() resultsLabel!: string;
  @Prop() isLastQuestion!: string;
  @Prop() showFeedback!: boolean;
  @Prop() showRedFlagsLabel!: string;
  @Prop({ default: false }) forceRedFlagsReview!: boolean;
  @Prop({ default: false }) isPartOfFolderSrcPool!: boolean;
  @Prop({default:false}) noFeedback !: boolean;
  @Prop() showLearnMoreButton?: boolean;
  $refs!: {
    submitButton: HTMLButtonElement;
  }

  redFlagsComplete: boolean = false;

  get showDefaultSubmit () :boolean{
    return Boolean(
      (!this.$slots['default'] && !this.learnMoreLabel?.length) ||
      (this.learnMoreLabel?.length && this.showLearnMoreButton)
    );
  }

  get finalButtonLabel() :string{
    return this.learnMoreLabel?.length ? this.learnMoreLabel : this.submitLabel; 
  }

  get redFlagsCount() {
    return document.querySelectorAll('[data-intro]').length;
  }
  getParsedRedFlagsMessage(redFlagsMessage: string) {
    return redFlagsMessage.replace(
      /\{redflagsCount\}/g,
      this.redFlagsCount.toString()
    );
  }
  public completeRedFlags() {
    this.redFlagsComplete = true;
    this.$emit('completeRedFlags');
  }

  get seenAllRedFlags() {
    return this.redFlagsComplete || this.isCorrect || !this.forceRedFlagsReview;
  }

  focusAndFixSkip() {
    let skip: HTMLElement | null = document.querySelector(
      '.introjs-skipbutton'
    );
    let doneButton: HTMLElement | null = document.querySelector(
      '.introjs-donebutton'
    );
    let prevButton: HTMLElement | null = document.querySelector(
      '.introjs-prevbutton'
    );
    if(this.seenAllRedFlags){
      if (skip) skip.focus();
    }else
    if(skip && doneButton) skip.classList.remove('introjs-invisible');
    else if(skip){
      skip.classList.add('introjs-invisible');
      if(prevButton) prevButton.focus();
    }
    

  }

  adjustModal(targetElement: HTMLElement) {
    let modalContainer = document.querySelector(
      '.introjs-tooltipReferenceLayer'
    );
    if (modalContainer) {
      modalContainer.setAttribute('aria-modal', 'true');
      modalContainer.setAttribute('aria-expanded', 'true');
      modalContainer.setAttribute('role', 'dialog');
      let hash = generateHash(targetElement.textContent as string).toString();
      targetElement.setAttribute('id', hash);
      modalContainer.setAttribute('aria-labelledby', hash);
    }
  }

  adjustModalContent(){
    let referenceLayer: HTMLElement | null = document.querySelector('.introjs-tooltiptext');

    if(referenceLayer)
      referenceLayer.focus();
    
        
    let modalInnerTooltip = document.querySelector(
      '.introjs-tooltipReferenceLayer .introjs-tooltip'
    );

    if(modalInnerTooltip) {
      modalInnerTooltip.setAttribute('role','alert'); 
      modalInnerTooltip.setAttribute('aria-live','assertive');
    }
  }

  fixPreviousButton() {
    let previousDisabledButton = document.querySelector(
      '.introjs-prevbutton.introjs-disabled'
    );
    let previousButton = document.querySelector('.introjs-prevbutton');
    if (previousDisabledButton) {
      previousDisabledButton.setAttribute('aria-disabled', 'true');
      previousDisabledButton.setAttribute('disabled', 'disabled');
    } else if (previousButton) {
      previousButton.removeAttribute('disabled');
      previousButton.removeAttribute('aria-disabled');
    }
  }

  startRedFlagsIntro() {
    let intro = (this as any).$intro();
    let localize = (this.$options.filters as any).localize;
    let trainingMainContent: HTMLElement | null = document.querySelector(
      '#MainContainer'
    );

    let focusAndFixSkip = this.focusAndFixSkip;
    let adjustModal = this.adjustModal;
    let fixPreviousButton = this.fixPreviousButton;
    let adjustModalContent = this.adjustModalContent;

    intro.setOptions({
      doneLabel: localize('Done'),
      nextLabel: localize('Next'),
      prevLabel: localize('Previous'),
      skipLabel: localize('Skip')
    });
    intro.onchange((targetElement: any) => {
      setTimeout(() => {
        targetElement.scrollIntoView();
        intro.refresh();
      });
    });
    intro.onafterchange(function(targetElement: HTMLElement) {
      let referenceLayer: HTMLElement | null = document.querySelector('.introjs-tooltiptext');
      if(referenceLayer){
        let HideContainer : HTMLElement | null = document.getElementById('HideContainer');
        if (!HideContainer ){
          HideContainer = document.createElement('div');
          HideContainer.id = 'HideContainer';
          HideContainer.style.visibility = 'visible';
          HideContainer.className = 'visibility-hidden';
          referenceLayer.insertAdjacentElement('beforebegin', HideContainer);
        }
        if(HideContainer)
          (HideContainer as any).innerHTML = targetElement.outerHTML;


        // Implementing focus for accessibily:
        referenceLayer.tabIndex = -1; 
      }
 
      if (
        !document.querySelector('.introjs-tooltip #htmlTrapFocusPortalStart')
      ) {
        Array.from(document.querySelectorAll('.introjs-tooltip a')).map(
          element => {
            element.addEventListener('keypress', (event: any) => {
              if (event.keyCode == 32 || event.keyCode == 13) 
                event.target.click();
              
            });
          }
        );
        Array.from(document.querySelectorAll('.introjs-bullets a')).map((element: any,index) => {
          element.innerHTML = `<span class="visibility-hidden">${localize('Go to red flag:')} ${index + 1}</span>`;
        });
      }

      let skip: HTMLElement | null = document.querySelector(
        '.introjs-skipbutton'
      );
      let buttonContainer: HTMLElement | null = document.querySelector(
        '.introjs-tooltipbuttons'
      );
      if (skip && buttonContainer) 
        if (intro._currentStep == intro._introItems.length - 1)
          buttonContainer.insertAdjacentElement('beforeend', skip);
        else buttonContainer.insertAdjacentElement('afterbegin', skip);
      
      focusAndFixSkip();

      HTMLTrapFocus(
        '.introjs-tooltip',
        '.introjs-bullets a',
        '.introjs-tooltipbuttons a:last-child'
      );
      adjustModal(targetElement);
      fixPreviousButton();

      setTimeout(() => {
        focusAndFixSkip();
        adjustModalContent();
        
      }, 400);
    });
    intro.onexit(function() {
      let nextButton = document.getElementById('optionControlNext');
      if (trainingMainContent)
        trainingMainContent.setAttribute('aria-hidden', 'false');
      if (nextButton) nextButton.focus();
    });
    intro.oncomplete(() => this.completeRedFlags());
    if (trainingMainContent)
      trainingMainContent.setAttribute('aria-hidden', 'true');
    intro.start();

    let modalContainer = document.querySelector(
      '.introjs-tooltipReferenceLayer'
    );
    if (modalContainer) {
      modalContainer.setAttribute('aria-modal', 'true');
      modalContainer.setAttribute('role', 'dialog');
    }
  }
  get getResultsLabel() {
    return this.resultsLabel !== undefined && this.resultsLabel.trim() !== ''
      ? this.resultsLabel
      : this.nextLabel;
  }

  @Watch('showLearnMoreButton')
  onShowLearnMoreButtonChange(val: boolean) {
    if(val)
      this.$nextTick(() => {
        this.$refs.submitButton.focus();
      });
  }
}
